import React from "react";

// 可重用主色圓角大按鈕
const MainActionButton = ({ children, loading, ...props }) => (
  <button
    {...props}
    className={
      `w-full py-3 rounded-full bg-amber-700 text-white font-bold text-xl md:text-2xl shadow-lg border-2 border-amber-300 hover:bg-amber-600 transition disabled:opacity-40 disabled:cursor-not-allowed duration-main-btn ` +
      (props.className || "")
    }
    style={{ letterSpacing: "0.05em", ...(props.style || {}) }}
  >
    {loading ? (
      <span className="inline-block w-6 h-6 border-4 border-amber-200 border-t-amber-700 rounded-full animate-spin align-middle" />
    ) : (
      children
    )}
  </button>
);

export default MainActionButton;
